import type {FormStatus} from 'nutshell-graphql-types';

export const getFormStatus = (status: FormStatus) => {
    switch (status) {
        case 'ACTIVATED':
            return {text: 'Active', level: 'success'};
        case 'IGNORED':
            return {text: 'Ignored', level: 'info--grey'};
        case 'NOT_ACTIVATED':
        default:
            return {
                text: 'Draft',
                level: 'info',
            };
    }
};

export const getStatusSecondaryText = (status: FormStatus, numMappedFields: number) => {
    switch (status) {
        case 'ACTIVATED':
            return `Adding data from ${numMappedFields} connected ${
                numMappedFields === 1 ? 'field' : 'fields'
            }`;
        case 'IGNORED':
            return 'Not syncing submission data';
        case 'NOT_ACTIVATED':
        default:
            return 'Activate to begin syncing submission data';
    }
};
